'use strict';

var React = require('react');
// var Episode = require('../episodes/Episode.jsx');
var Article = require('./Article');
var LinkButton = require('../elements/LinkButton.jsx');
var urlUtils = require('../../utils/urlUtils');


var MoreArticlesButton = React.createClass({

	displayName: 'MoreArticlesButton',

	propTypes: {
		visibleArticles: React.PropTypes.number.isRequired
	},
	
	contextTypes: { env: React.PropTypes.object.isRequired },

	render: function () {

		var program = this.props.program;

		if (program && program.articles && program.articles.length < this.props.visibleArticles) {
			return false;
		}

		return (
			<div className="svtse_latest-articles__navigation">
				<LinkButton url={urlUtils.articleTitleSearchUrl(program.title)}>
					Sök fler artiklar
				</LinkButton>
			</div>
		);
	}
});

module.exports = React.createClass({

	displayName: 'LatestArticles',

	propTypes: {
		program: React.PropTypes.shape({}).isRequired
	},

	getDefaultProps: function () {
		return {
			visibleArticles: 5
		};
	},

	_getLatestArticles: function () {
		var latestArticles = null;
		var program = this.props.program;

		if (program && program.articles && program.articles.length > 0) {
			latestArticles = program.articles.slice(0, this.props.visibleArticles);
		}
		return latestArticles;
	},

	render: function () {
		var articles = this._getLatestArticles();
		var program = this.props.program;

		if (!articles) {
			return false;
		}

		return (
			<div className="svtse_latest-articles">

				{articles.map(function (article, index) {
					return <Article program={program} article={article} key={index} />;
				})}

				<MoreArticlesButton program={program} visibleArticles={this.props.visibleArticles} />
			</div>
		);
	}
});



/** WEBPACK FOOTER **
 ** ./app/components/Program/LatestArticles.js
 **/